import { piniaInstance } from '../js/global';
import { defineStore } from 'pinia';

export const useCurrentUserStore = defineStore("current_user", {
  state: () => ({
    userID: '1',
    loggedIn: false,
    userName: "admin",
    userGroup: "admin",
    permissions: []
  }),
  getters: {
    getUserID(state) {
      return {
        'userID': this.userID,
      }
    },
    getUserName(state) {
      return {
        'username': this.userName,
      }
    },
    getUserGroup(state) {
      return {
        'userGroup': this.userGroup
      }
    },
    getPermissions(state){
      return this.permissions;
    }
  },
  actions: {
    async getData() {
      try {
        await fetch('/api/users/getuserdata')
          .then((response) => { return response.json(); })
          .then((data) => {
            this.userID = data.user_id;
            this.userName = data.user_name;
            this.userGroup = data.user_group;
            this.loggedIn = data.loggedIn;
            // console.log(`[CurrentUser] Usuario ${this.loggedIn ? 'autenticado' : 'no autenticado'}`);
          });
      }
      catch (error) {
        console.error('[CurrentUser] Error:', error);
        this.loggedIn = false;
      }
    },
    hydrate(){
      this.getData();
    }
  }
})(piniaInstance);